/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompiledReportCellTable {
    avgAcceleration?: Array<Array<number>>;
    avgSpeed?: Array<Array<number>>;
    avg?: Array<Array<number>>;
    colNames?: Array<string>;
    data?: Array<Array<number>>;
    max?: Array<Array<number>>;
    min?: Array<Array<number>>;
    rowNames?: Array<string>;
    title?: string;
}

